import { Accordion, AccordionDetails, Button, Grid, Typography } from '@mui/material'

import useStyles from '../index.styles'

import AccordionGroup from './accordion-group'

export const EXTRA_SENSORS_GROUP_KEY = 'extra-sensors'

const AccordionGroupExtraSensors = ({
  devices,
  isExpanded,
  onToggle,
  showActivateButton,
  onActivate,
  displayMode = 'accordion',
}: {
  devices: IDeviceType[]
  isExpanded: boolean
  onToggle: (key: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
  showActivateButton: boolean
  onActivate: () => void
  displayMode?: 'accordion' | 'panel'
}) => {
  const classes = useStyles

  if (devices.length === 0) return null

  const content = (
    <Grid container={true} size={12} sx={classes.extraSensorsPanel}>
      <Grid container={true} size={12} sx={classes.extraSensorsList}>
        {displayMode === 'panel' && (
          <Typography component="h3" variant="subtitle1" sx={classes.extraSensorsPanelHeader}>
            Extra Sensors
          </Typography>
        )}
        {devices.map((device) => (
          <Grid key={device.node.id} size={12} sx={classes.extraSensorListItem}>
            <Typography variant="body2">{device.node.vanity}</Typography>
          </Grid>
        ))}

        {showActivateButton && (
          <Button variant="contained" color="secondary" disableElevation size="small" sx={classes.extraSensorsActivateButton} onClick={onActivate}>
            Activate
          </Button>
        )}
      </Grid>
    </Grid>
  )

  if (displayMode === 'panel') {
    return (
      <Grid container={true} size={12} data-testid="extra-sensors-panel" sx={classes.extraSensorsStandalonePanel}>
        {content}
      </Grid>
    )
  }

  return (
    <Accordion
      data-testid="extra-sensors-accordion"
      expanded={isExpanded}
      onChange={onToggle(EXTRA_SENSORS_GROUP_KEY)}
      sx={[classes.accordion, classes.firstLevelAccordion]}
    >
      <AccordionGroup.SummaryTopLevel label="Extra Sensors" count={devices.length} hasAlert={false} showPlaceIcon={false} />
      <AccordionDetails sx={classes.accordionDetails}>{content}</AccordionDetails>
    </Accordion>
  )
}

export default AccordionGroupExtraSensors
